import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import logoImg from '../img/logo.png';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import TelegramIcon from '@mui/icons-material/Telegram';
import StoreIcon from '@mui/icons-material/Store';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';  
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

const menuItems = [
  {
    icon: <DashboardIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Website',
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <EmojiEventsIcon sx={{ color: '#17b785' }} className='me-2' />,
    text: 'Staking',
    url: '#sec',
    className: 'active',
  },
  {
    icon: <SwapHorizIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Exchange',
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <LayersOutlinedIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'NFTs',
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <StoreIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Marketplace',
    url: '#sec',
    target: '_blank',
  },
  {
    
    icon: <SportsEsportsIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Game',
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <AccountBalanceIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Forex',
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <CurrencyExchangeIcon sx={{ color: '#fff' }} className='me-2' />,
    text: 'Coinmarketcap',
    url: '#sec',
    target: '_blank',
  },
];

const socialLinks = [
  {
    icon: <TelegramIcon sx={{ fontSize: 24 }} />,
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <XIcon sx={{ fontSize: 20 }} />,
    url: '#sec',
    target: '_blank',
  },
  {
    icon: <FacebookIcon sx={{ fontSize: 24 }} />,
    url: '#sec',
    target: '_blank',
  },
];

function Sidebar() {
  return (
    <aside className="sidebar">
      <div className='sidebar-line'>
        <div className="sidebar-logo d-flex align-items-center justify-content-between">
          <a href="#sec" className="header-logo">
            <img src={logoImg} className='big-logo' height="50px" width="50px" alt='logo' />
            <img src={logoImg} className='mini-logo' height="40px" width="40px" alt='logo' />
          </a>
          <div className="menu-bt-sidebar toggle-sidebar-btn">
            <MenuOpenOutlinedIcon sx={{ color: "white" }} fontSize='large' />
          </div>
        </div>
      </div>
      <div className='sidebar-menu'>
        <ul className="sidebar-menu-nav">
          {menuItems.map((item, index) => (
            <li key={index}>
              <a href={item.url} target={item.target} rel="noreferrer" className={item.className || ''}>
                {item.icon}
                <span>{item.text}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className='sidebar-bottom'>
        <h5 className='text-center text-white'>Join Us</h5>
        <ul className='social-list'>
          {socialLinks.map((link, index) => (
            <li key={index}>
              <a href={link.url} target={link.target} rel="noreferrer">
                {link.icon}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
